<template>
  <div>
    <div class="_fc-t-header">
      <div class="_fc-t-menu">
        <el-button size="mini" type="danger" @click="showTemplate">生成组件</el-button>
        <el-button size="mini" type="danger" @click="saveJson">保存JSON</el-button>
        <el-button size="mini" type="danger" @click="dialogFormVisible = true">关联模板</el-button>
      </div>
    </div>
    <fc-designer style="height: 100%;min-height: 600px;" ref="designer"/>

    <el-dialog :title="title[type]" :visible.sync="state" class="_fc-t-dialog">
      <div ref="editor" v-if="state"></div>
      <span style="color: red;" v-if="err">输入内容格式有误!</span>
      <span slot="footer" class="dialog-footer" v-if="type > 2">
            <el-button @click="state = false" size="small">取 消</el-button>
            <el-button type="primary" @click="onOk" size="small">确 定</el-button>
          </span>
    </el-dialog>

    <el-dialog title="新建模板" :visible.sync="dialogFormCreatVisible">
      <el-form :model="form">
        <el-form-item label="模板名称" :label-width="formLabelWidth">
          <el-input v-model="formIn.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="选择插槽" :label-width="formLabelWidth">
          <el-select v-model="formIn.slot" multiple placeholder="请选择插槽">
            <el-option label="上传文件" value="upload_file"></el-option>
            <el-option label="选择框" value="select"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormCreatVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTemplate">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="关联模板" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="模板名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="选择关联模板" :label-width="formLabelWidth">
          <el-select v-model="form.templateId" placeholder="请选择模板">
            <el-option label="测试模板2" value="kjk5uxg5emlr"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import jsonlint from 'jsonlint-mod';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/lint/lint.css';
import CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/json-lint';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/vue/vue';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/css/css';
import 'codemirror/addon/mode/overlay';
import 'codemirror/addon/mode/simple';
import 'codemirror/addon/selection/selection-pointer';
import 'codemirror/mode/handlebars/handlebars';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/pug/pug';

import is from '@form-create/utils/lib/type';
import formCreate from '@form-create/element-ui';
import uniqueId from '@form-create/utils/lib/unique';

import { default as AlarmOrderApi } from '@/api/alarm/order/AlarmOrderApi.js'

const TITLE = ['生成规则', '表单规则', '生成组件', '设置生成规则', '设置表单规则'];

const label = '自定义上传'
const name = 'upload'
const upload = {
  icon: 'icon-upload',
  label,
  name,
  rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {
        action: 'http://10.254.6.186:9081/smp-service/common/file/upload',
        field: 'upload_file',
        title: '上传附件',
        listType: 'picture',
        handleIcon: true,
        name: 'file',
        limit: 3,
        onHandle: (file) => {
          let upperUrl = file.url.toUpperCase()
          if (upperUrl.indexOf(".PNG") != -1 || upperUrl.indexOf(".JPG") != -1 || upperUrl.indexOf(".JPEG") != -1 || upperUrl.indexOf(".BMP") != -1) {
            this.$alert('<img style="max-width: 390px" src="' + file.url + '" />', '图片预览', {
              dangerouslyUseHTMLString: true
            });
          } else {
            window.open(file.url)
          }
        },
        onSuccess(res, file, fileList) {
          console.log(res);
          console.log(file);
          file.url = 'https://picture.springland.com.cn/static/4ba86c0d23f048969a0df49a5cf541d2.jpg';
          console.log(this);

          console.log(fileList);
          return fileList.response.data;
        }
      }
    };
  },
  props() {
    return [{
      type: 'select',
      field: 'uploadType',
      title: '上传类型',
      value: 'image',
      options: [{label: '图片', value: 'image'}, {
        label: '文件',
        value: 'file'
      }]
    }, {type: 'input', field: 'action', title: '上传的地址(必填)'}, {
      type: 'Struct',
      field: 'headers',
      title: '设置上传的请求头部',
      props: {defaultValue: {}}
    }, {type: 'switch', field: 'multiple', title: '是否支持多选文件'}, {
      type: 'Struct',
      field: 'data',
      title: '上传时附带的额外参数',
      props: {defaultValue: {}}
    }, {type: 'input', field: 'name', title: '上传的文件字段名'}, {
      type: 'switch',
      field: 'withCredentials',
      title: '支持发送 cookie 凭证信息'
    }, {type: 'input', field: 'accept', title: '接受上传的文件类型（thumbnail-mode 模式下此参数无效）'}, {
      type: 'switch',
      field: 'autoUpload',
      title: '是否在选取文件后立即进行上传',
      value: true
    }, {
      type: 'switch',
      field: 'disabled',
      title: '是否禁用'
    }, {
      type: 'inputNumber',
      field: 'limit',
      title: '最大允许上传个数'
    }];
  }
}

export default {
  name: 'app',
  data() {
    return {
      state: false,
      value: null,
      title: TITLE,
      editor: null,
      err: false,
      type: -1,
      fileList: [],
      formLabelWidth: '120px',
      form: {
        templateId: '',
        name: ''
      },
      dialogFormVisible: false,
      dialogFormCreatVisible: false,
      formIn: {
        name: '',
        slot: ''
      }
    };
  },
  mounted() {
    //插入组件规则
    this.$refs.designer.addComponent(upload);
    //插入拖拽按钮到`main`分类下
    this.$refs.designer.appendMenuItem('main', {
      icon: upload.icon,
      name: upload.name,
      label: upload.label
    })
  },
  watch: {
    state(n) {
      if (!n) {
        this.value = null;
        this.err = false;
      }
    },
    value() {
      this.load();
    }
  },
  methods: {
    sure() {
      let templateId = uniqueId()
      console.log(templateId)

      let templateRules = this.$refs.designer.getRule();
      let templateOptions = this.$refs.designer.getOption();
      let jsonData = {
        templateId: templateId,
        templateName: this.form.name,
        templateRules: templateRules,
        templateOptions: templateOptions,
        contactTemplateId: this.form.templateId
      }
      console.log(jsonData)

      localStorage.setItem('template_concat:' + this.form.templateId, JSON.stringify(jsonData));
      this.$message({
        type: 'success',
        message: '保存成功'
      });
    },
    // 保存模板
    saveTemplate() {
      let that = this
      let templateId = uniqueId()
      console.log(templateId)
      let templateName = this.formIn.name
      let templateRules = this.$refs.designer.getRule();
      let templateOptions = this.$refs.designer.getOption();
      let jsonData = {
        templateId: templateId,
        templateName: templateName,
        templateRules: JSON.stringify(templateRules),
        templateOptions: JSON.stringify(templateOptions),
        slot: JSON.stringify(this.formIn.slot)
      }
      localStorage.setItem('templateNew:' + templateId, JSON.stringify(jsonData));
      // 保存模板
      AlarmOrderApi.createTemplate(jsonData).then(res => {
        console.log(res)
        res = res.data
        if (res.code == 200) {
          that.$message.success('保存成功！')
          that.dialogFormCreatVisible = false
        } else {
          that.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        that.$message.warning("系统错误！请稍后尝试")
      })
    },
    saveJson() {
      this.dialogFormCreatVisible = true
    },
    load() {
      let val;
      if(this.type === 2){
        val = this.value;
      }else if(this.type === 0){
        val = formCreate.toJson(this.value, 2);
      }else{
        val = JSON.stringify(this.value, null, 2);
      }
      this.$nextTick(() => {
        this.editor = CodeMirror(this.$refs.editor, {
          lineNumbers: true,
          mode: this.type === 2 ? {name: 'vue'} : 'application/json',
          gutters: ['CodeMirror-lint-markers'],
          lint: true,
          line: true,
          tabSize: 2,
          lineWrapping: true,
          value: val || ''
        });
        this.editor.on('blur', () => {
          this.err = this.editor.state.lint.marked.length > 0;
        });
      });
    },
    onValidationError(e) {
      this.err = e.length !== 0;
    },
    showJson() {
      this.state = true;
      this.type = 0;
      this.value = this.$refs.designer.getRule();
    },
    showOption() {
      this.state = true;
      this.type = 1;
      this.value = this.$refs.designer.getOption();
    },
    showTemplate() {
      this.state = true;
      this.type = 2;
      this.value = this.makeTemplate();
    },
    setJson() {
      this.state = true;
      this.type = 3;
      this.value = [];
    },
    setOption() {
      this.state = true;
      this.type = 4;
      this.value = {form: {}};
    },
    onOk() {
      if (this.err) return;
      let val = JSON.parse(this.editor.getValue());
      if (this.type === 3) {
        if (!Array.isArray(val)) {
          this.err = true;
          return;
        }
        this.$refs.designer.setRule(val);
      } else {
        if (!is.Object(val) || !val.form) {
          this.err = true;
          return;
        }
        this.$refs.designer.setOption(val);
      }
      this.state = false;
    },
    makeTemplate() {
      const rule = this.$refs.designer.getRule();
      const opt = this.$refs.designer.getOption();
      return `<template>
  <form-create
    v-model="fapi"
    :rule="rule"
    :option="option"
    @submit="onSubmit"
  ></form-create>
</template>

<script>
import formCreate from "@form-create/element-ui";

export default {
  data () {
    return {
        fapi: null,
        rule: formCreate.parseJson('${formCreate.toJson(rule).replaceAll('\\','\\\\')}'),
        option: formCreate.parseJson('${JSON.stringify(opt)}')
    }
  },
  methods: {
    onSubmit (formData) {
      //todo 提交表单
    }
  }
}
<\/script>`;
    }
  },
  beforeCreate() {
    window.jsonlint = jsonlint;
  }
};


</script>

<style>
._fc-t-header {
  height: 60px;
  margin: 0 20px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: default;
}

._fc-t-logo {
  height: 26px;
}

._fc-t-name {
  display: inline-block;
  color: rgba(0, 0, 0, 0.8);
  font-size: 20px;
  font-weight: 600;
  margin-left: 5px;
}

._fc-t-menu {
  position: absolute;
  right: 0;
}

._fc-t-menu i {
  font-size: 12px;
}

body {
  padding: 0;
  margin: 0;
  display: flex !important;
  flex-direction: column !important;
}

#app {
  display: flex;
  flex-direction: column;
  flex: 1;
}

._fc-copyright {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
  font-size: 16px;
  border-top: 1px solid #ECECEC;
  background-color: #fff;
  cursor: pointer;
}

._fc-t-dialog .CodeMirror {
  height: 650px;
}

._fc-t-dialog .CodeMirror-line {
  line-height: 16px !important;
  font-size: 13px !important;
}

.CodeMirror-lint-tooltip {
  z-index: 2021 !important;
}

._fc-t-dialog .el-dialog__body {
  padding: 0px 20px;
}
._fc-b-item{
  display: flex;
}
</style>
